import { render } from "./Galeria.vue?vue&type=template&id=76a3a094&scoped=true"
import script from "./Galeria.vue?vue&type=script&lang=js"
export * from "./Galeria.vue?vue&type=script&lang=js"

import "./Galeria.vue?vue&type=style&index=0&id=76a3a094&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a3a094"]])

export default __exports__